import React from 'react';

export default (props) => {
  var useTag = `<use xlink:href="/styles/mysource_files/sprite.svg#${props.imageName}" />`;
  return <svg className={props.className + (props.large?' c-icon--large':'')} dangerouslySetInnerHTML={{__html: useTag }} />;  
}